import { Drawer } from 'antd';
import { Vendor, VendorType, updateVendorAsync } from '../../modules/vendors';
import VendorCompanyCreateUpdateComponent from '../../components/vendors/VendorCompanyCreateUpdateComponent';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getVendorConfig } from '../../api/constlink';
import VendorWorkerCreateUpdateComponent from '../../components/vendors/VendorWorkerCreateUpdateComponent';

interface VendorEditDrawerProps {
  config: any;
  vendor: Vendor;
  visible: boolean;
  onClose: () => void;
}

function VendorEditDrawer({
  config,
  vendor,
  visible,
  onClose,
}: VendorEditDrawerProps) {
  const [vendorConfig, setVendorConfig] = useState<any>();
  const dispatch = useDispatch();
  useEffect(() => {
    if (visible === false) return;
    (async () => {
      // setUploadProps(
      //   await initializeUploadProps(
      //     getInvoiceFileAPIPath(config.enterpriseId, config.projectId),
      //   ),
      // );
      const _vendorConfig = await getVendorConfig({
        enterpriseId: config.enterpriseId,
      });
      setVendorConfig({ ..._vendorConfig });
    })();
  }, [config, visible]);

  const onUpdate = async (application: any) => {
    dispatch(
      updateVendorAsync.request({
        ...config,
        vendor: {
          ...vendor,
          application: { ...application },
        },
      }),
    );
    onClose();
  };

  return (
    <>
      {vendor && vendorConfig && (
        <Drawer
          width={600}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && vendor.type === VendorType.COMPANY && (
            <VendorCompanyCreateUpdateComponent
              vendor={vendor}
              vendorConfig={vendorConfig}
              onCreate={onUpdate}
              onCancel={onClose}
            />
          )}
          {visible && vendor.type === VendorType.WORKER && (
            <VendorWorkerCreateUpdateComponent
              vendor={vendor}
              vendorConfig={vendorConfig}
              onCreate={onUpdate}
              onCancel={onClose}
            />
          )}
        </Drawer>
      )}
    </>
  );
}

export default VendorEditDrawer;
